import React from 'react';
import { useTheme } from '@mui/material';
import {
  InsertDriveFile as FileIcon,
  Image as ImageIcon,
  PictureAsPdf as PdfIcon,
  CloudUpload as UploadIcon,
} from '@mui/icons-material';
import { ACCEPTED_FILE_TYPES } from '../../../types/message';

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export const getFileIcon = (fileType: string, isUploading: boolean = false): React.ReactElement => {
  if (isUploading) {
    return React.createElement(UploadIcon);
  }
  if (fileType.startsWith('image/')) {
    return React.createElement(ImageIcon);
  }
  if (fileType === 'application/pdf') {
    return React.createElement(PdfIcon);
  }
  return React.createElement(FileIcon);
};

export const validateFile = (
  file: File,
  maxFileSize: number,
  acceptedTypes: string[]
): string | null => {
  if (file.size > maxFileSize) {
    return `ファイルサイズは${formatFileSize(maxFileSize)}以下にしてください`;
  }

  const isAccepted = acceptedTypes.some(type => {
    if (type === ACCEPTED_FILE_TYPES.ALL) return true;
    return type.split(',').some(ext => 
      file.name.toLowerCase().endsWith(ext.replace('.', ''))
    );
  });

  if (!isAccepted) {
    return '対応していないファイル形式です';
  }

  return null;
};

export const simulateUpload = async (
  fileId: string,
  setExtendedFiles: React.Dispatch<React.SetStateAction<any[]>>
): Promise<void> => {
  return new Promise((resolve) => {
    let progress = 0;
    const interval = setInterval(() => {
      progress += Math.random() * 15 + 5; // 5-20%ずつ進行
      
      setExtendedFiles(prev => prev.map(file => 
        file.id === fileId 
          ? { 
              ...file, 
              uploadState: { 
                isUploading: true, 
                progress: Math.min(progress, 100),
                isCompleted: false 
              } 
            }
          : file
      ));

      if (progress >= 100) {
        clearInterval(interval);
        // アップロード完了状態に変更
        setTimeout(() => {
          setExtendedFiles(prev => prev.map(file => 
            file.id === fileId 
              ? { 
                  ...file, 
                  uploadState: { 
                    isUploading: false, 
                    progress: 100,
                    isCompleted: true 
                  } 
                }
              : file
          ));
          resolve();
        }, 200);
      }
    }, 100 + Math.random() * 200); // ランダムな間隔
  });
}; 